import { __assign, __rest } from "tslib"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import clsx from 'clsx';
import styles from './styles.css.js';
import React from 'react';
export function TableBodyCell(_a) {
  var className = _a.className,
      style = _a.style,
      children = _a.children,
      wrapLines = _a.wrapLines,
      isFirstRow = _a.isFirstRow,
      isLastRow = _a.isLastRow,
      isSelected = _a.isSelected,
      isNextSelected = _a.isNextSelected,
      isPrevSelected = _a.isPrevSelected;
  return React.createElement("td", {
    style: style,
    className: clsx(className, styles['body-cell'], wrapLines && styles['body-cell-wrap'], isFirstRow && styles['body-cell-first-row'], isLastRow && styles['body-cell-last-row'], isSelected && styles['body-cell-selected'], isNextSelected && styles['body-cell-next-selected'], isPrevSelected && styles['body-cell-prev-selected'])
  }, children);
}
export function TableBodyCellContent(_a) {
  var item = _a.item,
      column = _a.column,
      rest = __rest(_a, ["item", "column"]);

  return React.createElement(TableBodyCell, __assign({}, rest), column.cell(item));
}